module.exports = __webpack_public_path__ + "img/modal-info-icon.9d4caaee.svg";